import './IconButton.scss';
import React from 'react';
import cx from 'classnames'

type Props = {
    onClick?: (param?) => void,
    icon?: string,
    size?: string,
    color?: string,
    disabled?: boolean,
    src?: string,
    className?: string,
    withBorder?: boolean,
    name?: string
}

export const IconButton = ({
    className,
    onClick,
    icon,
    size,
    color,
    disabled,
    src,
    withBorder,
    name,
    ...rest
}: Props) => {
    const classes = cx(
        'b-icon-button',
        color, 
        size,
        className,
        { 
            [`svg-background-${icon}`]: !src,
            'border': withBorder,
            'disabled': disabled,
        },
    )

    return (
        <div
            className={classes}
            onClick={onClick}
            {...rest}
            data-testid={name}
        >
            {src && (
                <div className="b-icon-button__image-container">
                    <img 
                        className="b-icon-button__image"
                        src={src} 
                        alt="icon" 
                    />
                </div>
            )}
        </div>
    )
}

export default IconButton